import React, { useEffect, useState } from 'react';
import { useUser } from '../contexts/UserContext';
import { Settings } from './Settings';
import { HlsAudioPlayer } from '../utils/HlsAudioPlayer';

interface NewUserProps {
  hlsAudioPlayer: HlsAudioPlayer;
}

const NewUser: React.FC<NewUserProps> = ({ hlsAudioPlayer }) => {
  const { user } = useUser();
  const [userInfo, setUserInfo] = useState(user?.settings || {
    preferredName: '',
    cityState: '',
    address: '',
    aboutYou: ''
  });
  const [, setIsSettingsOpen] = useState(true);

  useEffect(() => {
    hlsAudioPlayer.play('https://audio.locationstation.net/new-user-intro/new-user-intro.m3u8').catch((error) => {
      console.error('Error playing audio:', error);
    });
  }, [hlsAudioPlayer]);

  return (
    <div className="flex flex-col justify-center h-screen bg-gradient-to-b from-blue-50 to-white">
      <Settings
        onClose={() => setIsSettingsOpen(false)}
        settings={userInfo}
        setSettings={setUserInfo}
      />
    </div>
  );
};

export default NewUser;